import { DataTablePageSizeEnum, SortEnum } from '@/enums';
import { VerificationTypesEnum } from '@/lib/enum';
import { useParams } from 'react-router-dom';
import { useQueryParams } from '@/hooks';
import dayjs from 'dayjs';

const useUrlParams = () => {

  const { values: [sortType, date, limit, page, authorIds], setValue, setValues, updateSearchParams } = useQueryParams(
    ['sortType', 'date', 'limit', 'page', 'authorIds'],
    {
      date: dayjs().format('YYYY-MM-DD'),
      limit: DataTablePageSizeEnum._50,
      sortType: SortEnum.DESC,
      page: 1
    }
  );
  const { type } = useParams() as { type: string };

  return ({
    type: (
      type?.toLowerCase() === VerificationTypesEnum.IDENTITY.toLowerCase()
        ? VerificationTypesEnum.IDENTITY
        : type?.toLowerCase() === VerificationTypesEnum.PROFILE_PHOTO.toLowerCase()
          ? VerificationTypesEnum.PROFILE_PHOTO
          : undefined
    ),
    authorIds: authorIds as (string[] | undefined),
    limit: limit as DataTablePageSizeEnum,
    sortType: sortType as SortEnum,
    date: (
      date && dayjs(date).isValid()
        ? dayjs(date).toDate()
        : dayjs().toDate()
    ),
    dateString: date as string,
    updateSearchParams,
    setValues,
    setValue,
    page
  });

};

export default useUrlParams;
